const snmpActions = [
  'FILE_EXCHANGE_EXECUTE',
  'FILE_EXCHANGE_ABORT',
  'FILE_EXCHANGE_STATUS',
  'SPECTRUM_ANALYSIS_EXECUTE',
  'SPECTRUM_ANALYSIS_ABORT',
  'SPECTRUM_ANALYSIS_STATUS',
  'UPDATE_EXECUTE',
  'UPDATE_ABORT',
  'UPDATE_STATUS',
  'SPECIFIC_COMMAND_EXECUTE',
  'SPECIFIC_COMMAND_ABORT',
  'SPECIFIC_COMMAND_STATUS',
  'MANAGEMENT_EXECUTE',
  'MANAGEMENT_GET_VALUES',
  'GET_LAN_MODULES',
  'GET_GATEWAY_DESCRIPTION',
  'SET_CONFIGURATION',
  'GET_CONFIGURATION',
  'GET_CONFIGURATIONS',
  'GET_HASH_CONFIGURATIONS',
  'SET_CONTROLS',
  'GET_CONTROLS',
  'SET_VALUES',
  'GET_VALUES',
  'GET_STATISTIC',
  'GET_STATISTIC_INDEX',
  'GET_VERSION',
  'GET_VERSIONS',
  'GET_HASH_VERSIONS',
  'NOTIFICATION_COLD_START',
  'NOTIFICATION_START',
  'NOTIFICATION_SHUTDOWN',
  'NOTIFICATION_RESTART',
  'NOTIFICATION_IP_CHANGE',
  'NOTIFICATION_POWER_LOST',
  'NOTIFICATION_AUTOMATIC_SYSTEM_RESTORATION',
  'NOTIFICATION_AUTOMATIC_SYSTEM_RESTORATION_FACTORY',
  'NOTIFICATION_PREVIOUS_CONFIG_RESTORATION',
  'NOTIFICATION_UPDATE_EXECUTE',
  'NOTIFICATION_UPDATE_ABORT',
  'NOTIFICATION_FILE_EXCHANGE_EXECUTE',
  'NOTIFICATION_FILE_EXCHANGE_ABORT',
  'NOTIFICATION_SPECTRUM_ANALYSIS_EXECUTE',
  'NOTIFICATION_SPECTRUM_ANALYSIS_ABORT',
  'NOTIFICATION_SPECIFIC_COMMAND_EXECUTE',
  'NOTIFICATION_SPECIFIC_COMMAND_ABORT',
  'NOTIFICATION_AUTHENTICATION_FAILURE',
  'ALARM_CPU',
  'ALARM_DISK_SYSTEM',
  'ALARM_DISK_USER',
  'ALARM_DOOR_EVENT',
  'ALARM_GPS',
  'ALARM_RAM',
  'ALARM_RSSI',
  'ALARM_TEMPERATURE',
  'SIMULATE_ALARM_DOOR_EVENT',
  'SIMULATE_ALARM_GPS_EVENT',
  'CONNEXION_CHANGE',
  'GATEWAY_DESCRIPTION_CHANGE',
  'GATEWAY_IP_PORT_CHANGE',
  'STATISTIC',
  'HELLO',
  'NETWORK_EVENT',
  'PING_EVENT',
  'RETURN_TIMEOUT_STATUS',
  'RETURN_SENDING_STATUS',
  'RETURN_KO_STATUS',
  'PING'
]

export default snmpActions
